var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.499 3H5.49985C4.12103 3 3 4.12103 3 5.49985V16.7492C3 18.128 4.12103 19.249 5.49985 19.249H9.24963V22.5301C9.24963 22.9129 9.68711 23.1355 9.99568 22.909L14.8743 19.249H20.499C21.8778 19.249 22.9988 18.128 22.9988 16.7492V5.49985C22.9988 4.12103 21.8778 3 20.499 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0a3435c8a6f3019c06cae81b435cf6b4.svg";
export { ForwardRef as ReactComponent };